import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../../common/ConfirmDialog';

interface StopUsingDialogProps {
    open: boolean;
    onClose: () => void;
    headerText?:string
    bodyText?:string
    onConfirmRetrieval: () => void;
}

const ConfirmRetrievalDialog = (props: StopUsingDialogProps) => {
    const { t } = useTranslation();

    const onConfirmFinishSenderRetrieval = () => {
        props.onConfirmRetrieval();
        props.onClose();
    };

    return (
        <ConfirmDialog
            open={props.open}
            title={props.headerText ?? t('itemRetrieval.lockerOpen.dialog.header')}
            content={props.bodyText ?? t('itemRetrieval.lockerOpen.dialog.content')}
            cancelText={t('itemRetrieval.lockerOpen.dialog.cancel_button')}
            confirmText={t('itemRetrieval.lockerOpen.dialog.confirm_button')}
            onClose={props.onClose}
            onConfirm={onConfirmFinishSenderRetrieval}
        />
    );
};

export default ConfirmRetrievalDialog;
